export { isEqual } from './isEqual'
export { onlypositivenumbers } from './onlypositivenumbers'
export { positivenumbers } from './positivenumbers'
export { arrayToObject } from './arraytoobject'
export { checkRole } from './checkRole'
export { onlydates } from './onlydates'
export { default as isEmpty }  from './isEmpty'
export { default as isArrayFrom }  from './isArrayFrom';


// WEBPACK FOOTER //
// ./src/utils/functions/index.js